import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=44e8097c&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e8097c')) {
      api.createRecord('44e8097c', component.options)
    } else {
      api.reload('44e8097c', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=44e8097c&", function () {
      api.rerender('44e8097c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/Banner.vue"
export default component.exports